import { useCallback } from 'react';
import { useAppScopeStore } from '@frontend/scope';
import { useAppFlagStore } from '@frontend/shared';
import {
  PurchaseDeviceTypeLinksMap,
  PurchaseDeviceType,
  PurchaseDeviceTypeCFMap,
  PurchaseDeviceTypeFFMap,
} from '../constants';

interface UsePurchaseDeviceActionsProps {
  devices: PurchaseDeviceType[];
  locationIds?: string[];
}
export const usePurchaseDeviceActions = ({ devices, locationIds }: UsePurchaseDeviceActionsProps) => {
  const { selectedLocationIds: scopedLocationIds } = useAppScopeStore();
  const { getCustomizationFlagValue, getFeatureFlagValue } = useAppFlagStore();

  const selectedLocationIds = locationIds || scopedLocationIds;

  const availableDevices = [...new Set(devices)].filter((device) => {
    const isFFActive = getFeatureFlagValue({
      locationIds: selectedLocationIds,
      flagName: PurchaseDeviceTypeFFMap[device],
    });
    const isCFActive = getCustomizationFlagValue({
      locationIds: selectedLocationIds,
      flagName: PurchaseDeviceTypeCFMap[device],
    });
    return isFFActive && isCFActive;
  });

  const handleDevicePurchaseAction = useCallback((device: PurchaseDeviceType) => {
    switch (device) {
      case PurchaseDeviceType.PAYMENT_TERMINAL:
      case PurchaseDeviceType.DESK_PHONE:
        window.open(PurchaseDeviceTypeLinksMap[device], '_blank', 'noopener,noreferrer');
        break;
      default:
        return;
    }
  }, []);

  return {
    handleDevicePurchaseAction,
    availableDevices,
  };
};
